import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  ClalChooseStationStepFormFieldsEnum,
  IPlaceInfoLandingModel,
  yupLanding,
} from "@ryde/utils-landings";

export enum ClalWorkerType {
  Employee = "employee",
  Contractor = "contractor",
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useYupChooseStationLandingValidationSchema = () => {
  const { t } = useTranslation();
  const yupChooseStationLandingValidationSchema = useMemo(() => {
    const workerIdPath = t(
      `landing.formLabel.${ClalChooseStationStepFormFieldsEnum.WorkerId}`,
    );
    return {
      [ClalChooseStationStepFormFieldsEnum.WorkerId]: yupLanding
        .number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value,
        )
        .typeError(t("landing.validation.numberOnly", { path: workerIdPath }))
        .required(t("landing.validation.required", { path: workerIdPath }))
        .positive(t("landing.validation.positive", { path: workerIdPath }))
        .integer(t("landing.validation.integer", { path: workerIdPath })),
      [ClalChooseStationStepFormFieldsEnum.FirstName]: yupLanding
        .string()
        .required(),
      [ClalChooseStationStepFormFieldsEnum.LastName]: yupLanding
        .string()
        .required(),
      [ClalChooseStationStepFormFieldsEnum.HomeAddress]: yupLanding
        .object<IPlaceInfoLandingModel>()
        .shape({
          fullAddress: yupLanding.string().required(),
          latitude: yupLanding.number().nullable().optional(),
          longitude: yupLanding.number().nullable().optional(),
        })
        .required(),
      [ClalChooseStationStepFormFieldsEnum.WorkerType]: yupLanding
        .string()
        .required(),
      [ClalChooseStationStepFormFieldsEnum.SourceStation2Id]: yupLanding
        .number()
        .required(),
      [ClalChooseStationStepFormFieldsEnum.Phone]: yupLanding
        .string()
        .required(),
      [ClalChooseStationStepFormFieldsEnum.Unit]: yupLanding
        .string()
        .when(ClalChooseStationStepFormFieldsEnum.WorkerType, {
          is: ClalWorkerType.Contractor,
          then: schema => schema.required(),
          otherwise: schema => schema.optional(),
        }),
    };
  }, [t]);

  return {
    yupChooseStationLandingValidationSchema,
  };
};
